import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { displayTime } from '../alarm-updates/util';
import { DispatchTimelineEntryViewCompact } from './DispatchTimelineEntryViewCompact';
import { DispatchTimelineEntryViewWide } from './DispatchTimelineEntryViewWide';
import {
  DispatchTimelineRowChrome,
  DispatchTimelineRowProps,
} from './DispatchTimelineRowChrome';

dayjs.extend(utc);
dayjs.extend(timezone);

export type { DispatchTimelineRowProps };

export function DispatchTimelineRowCompact(props: DispatchTimelineRowProps) {
  return (
    <DispatchTimelineRowChrome
      {...props}
      View={DispatchTimelineEntryViewCompact}
      largeEditor={false}
      dotRowClass="h-5"
    />
  );
}

export function DispatchTimelineRowWide(props: DispatchTimelineRowProps) {
  const d = dayjs(displayTime(props.ev, props.pending));
  const zoned = props.timezone ? d.tz(props.timezone) : d;

  return (
    <DispatchTimelineRowChrome
      {...props}
      View={DispatchTimelineEntryViewWide}
      largeEditor
      dotRowClass="h-6"
      timestampColumn={
        <div className="w-24 shrink-0">
          <div className="text-onlight-text-1 dark:text-ondark-text-1 flex h-6 items-start text-sm font-medium">
            {zoned.format('HH:mm:ss')}
          </div>
          <div className="text-onlight-text-2 dark:text-ondark-text-2 text-xs">
            {zoned.format('DD-MM-YYYY')}
          </div>
        </div>
      }
    />
  );
}
